import pLimit from 'p-limit'
import { useDwtStore } from './store'
import { isBlankImage as isBlankImageNow } from '../buffer'
import { decodeBarcode as decodeBarcodeNow } from '../barcodeReader'
import type { ImageID } from '../types'
import type { BarcodeInfo } from '../barcodeReader/types'

const queue = pLimit(1)

export const isBlankImageQueue = (imageId: ImageID): Promise<boolean> => {
    const blankPageSeparator = useDwtStore.getState().settings.blankPageSeparator
    const ignoreBlankPages = useDwtStore.getState().settings.ignoreBlankPages
    const blankPageDetecionEnabled = blankPageSeparator || ignoreBlankPages

    if (!blankPageDetecionEnabled) {
        console.debug('blankPageDetecion disabled', imageId)
        return Promise.resolve(false)
    }

    return queue(() => isBlankImageNow(imageId))
}

export const decodeBarcodeQueue = (imageId: ImageID): Promise<BarcodeInfo> => {
    const barcodeReaderEnabled = useDwtStore.getState().settings.barcodeReader
    if (!barcodeReaderEnabled) {
        console.debug('decodeBarcode disabled', imageId)
        return Promise.resolve({ textResults: [], settings: 'disabled' })
    }

    return queue(() => decodeBarcodeNow(imageId))
}
